// extracted by mini-css-extract-plugin
export default {"popupInner":"TwoFactorAuthenticationPopup__popupInner--1NW","layout":"TwoFactorAuthenticationPopup__layout--3Nv","container":"TwoFactorAuthenticationPopup__container--2qN"};